import { useDispatch } from 'react-redux';
import FJImageExtenderRatio from '../view/FJImageExtenderRatio';
import FJActionImageExtender from '../../../../redux/action/FJActionImageExtender';
import { useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJImageExtenderRatioContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const curRatioName = useSelector(state => state.imageExtender.curRatioName);

    const changeRatio = ratio => {
        dispatch(FJActionImageExtender.setCurRatioNameAction(ratio));
    };

    return <FJImageExtenderRatio curRatioName={curRatioName} changeRatio={changeRatio} />;
};

export default FJImageExtenderRatioContainer;
